import React from "react";
import {
  Heading,
  Thead,
  Tbody,
  Tr,
  TableContainer,
  Text
} from "@chakra-ui/react";

import { scrollBarCss } from "theme/scrollBarCss";
import {
  TableHead as Th,
  SizesTable as Table,
  Cell as Td
} from "./SizeGuide.styles";
import { CrewNeckGuide } from "./CrewNeckGuide";

type Props = {
  productTitle?: string;
};

export const SizeGuide: React.FC<Props> = ({ productTitle }) => {
  if (productTitle === "Crew Neck Sweatshirt") return <CrewNeckGuide />;

  return (
    <TableContainer mb={3} sx={scrollBarCss}>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Beauty Pie Size</Th>
            <Th>Size 1</Th>
            <Th>Size 2</Th>
            <Th>Size 3</Th>
            <Th>Size 4</Th>
            <Th>Size 5</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Th>Size</Th>
            <Td>XXS-XS</Td>
            <Td>S-M</Td>
            <Td>L-XL</Td>
            <Td>2XL-3XL</Td>
            <Td>4XL-5XL</Td>
          </Tr>
          <Tr>
            <Th>UK Sizing</Th>
            <Td>6-8</Td>
            <Td>10-12</Td>
            <Td>12-14</Td>
            <Td>16-18</Td>
            <Td>20-22</Td>
          </Tr>
          <Tr>
            <Th>US Sizing</Th>
            <Td>2-4</Td>
            <Td>6-8</Td>
            <Td>8-10</Td>
            <Td>12-14</Td>
            <Td>16-18</Td>
          </Tr>
        </Tbody>
      </Table>

      <Heading size="lg" as="h3" variant="demi3" mt={3} mb={3}>
        Garment measurements
      </Heading>

      <Table variant="simple">
        <Tbody>
          <Tr>
            <Th>
              Chest{" "}
              <Text as="span" fontWeight="normal">
                (cm)
              </Text>
            </Th>
            <Td>92</Td>
            <Td>104</Td>
            <Td>116</Td>
            <Td>131</Td>
            <Td>146</Td>
          </Tr>
          <Tr>
            <Th>
              Chest{" "}
              <Text as="span" fontWeight="normal">
                (inch)
              </Text>
            </Th>
            <Td>36.2</Td>
            <Td>41</Td>
            <Td>45.6</Td>
            <Td>51.6</Td>
            <Td>57.4</Td>
          </Tr>
          <Tr>
            <Th>
              Waist{" "}
              <Text as="span" fontWeight="normal">
                (cm)
              </Text>
            </Th>
            <Td>54</Td>
            <Td>66</Td>
            <Td>78</Td>
            <Td>90</Td>
            <Td>102</Td>
          </Tr>
          <Tr>
            <Th>
              Waist{" "}
              <Text as="span" fontWeight="normal">
                (inch)
              </Text>
            </Th>
            <Td>21.3</Td>
            <Td>26</Td>
            <Td>30.7</Td>
            <Td>35.4</Td>
            <Td>40.2</Td>
          </Tr>
          <Tr>
            <Th>
              Hip{" "}
              <Text as="span" fontWeight="normal">
                (cm)
              </Text>
            </Th>
            <Td>88</Td>
            <Td>100</Td>
            <Td>112</Td>
            <Td>124</Td>
            <Td>136</Td>
          </Tr>
          <Tr>
            <Th>
              Hip{" "}
              <Text as="span" fontWeight="normal">
                (inch)
              </Text>
            </Th>
            <Td>34.6</Td>
            <Td>39.4</Td>
            <Td>44.1</Td>
            <Td>48.8</Td>
            <Td>53.5</Td>
          </Tr>
          <Tr>
            <Th>
              Inside leg{" "}
              <Text as="span" fontWeight="normal">
                (cm)
              </Text>
            </Th>
            <Td>76</Td>
            <Td>76</Td>
            <Td>76</Td>
            <Td>76</Td>
            <Td>76</Td>
          </Tr>
          <Tr>
            <Th>
              Inside leg{" "}
              <Text as="span" fontWeight="normal">
                (inch)
              </Text>
            </Th>
            <Td>29.9</Td>
            <Td>29.9</Td>
            <Td>29.9</Td>
            <Td>29.9</Td>
            <Td>29.9</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};
